import { render, staticRenderFns } from "./form-data-publisher-group.vue?vue&type=template&id=019b6144&"
import script from "./form-data-publisher-group.vue?vue&type=script&lang=js&"
export * from "./form-data-publisher-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports